import request from '@/utils/request'

export const getTrackMerchant = ({ type, page, size, keywords: merchantName }) => {
  return request({
    url: `/trace/merchant/${type}/${page}/${size}`,
    params: {
      merchantName
    }
  })
}

export const putTrackMerchantRetailer = (data) => {
  return request({
    method: 'put',
    url: '/trace/merchant/2',
    data
  })
}

export const putTrackMerchantSupplier = (data) => {
  return request({
    method: 'put',
    url: '/trace/merchant/1',
    data
  })
}

export const getTrackMerchantDetail = (type, id) => {
  return request({
    url: `/trace/merchant/${type}/${id}`
  })
}

export const postTrackMerchantSupplier = (data) => {
  return request({
    method: 'post',
    url: '/trace/merchant',
    data: {
      merchantType: 1,
      ...data
    }
  })
}

export const postTrackMerchantRetailer = (data) => {
  return request({
    method: 'post',
    url: '/trace/merchant',
    data: {
      merchantType: 2,
      ...data
    }
  })
}

export const deleteMerchantDel = ({ id }) => {
  return request({
    method: 'delete',
    url: `/trace/merchant/${id}`
  })
}

export const delMerchantList = (data) => {
  return request({
    method: 'delete',
    url: '/trace/merchant/all',
    data
  })
}
